import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAppConfigAction } from 'root-redux/actions/common'
import { selectAppName } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { getMobileOperatingSystem } from 'helpers/getMobileOperatingSystem'

import { AppName, PlatformOS } from 'root-constants'

export const useInitAppConfig = (): void => {
  const dispatch: TAppDispatch = useDispatch()
  const appName = useSelector(selectAppName)

  useEffect(() => {
    if (!appName) return

    const clientOS = getMobileOperatingSystem()

    let platform: string | undefined

    if (appName === AppName.HELLO_PIANO && clientOS !== PlatformOS.UNKNOWN) {
      platform = clientOS.toLowerCase()
    }

    dispatch(getAppConfigAction(appName, platform))
  }, [dispatch, appName])
}
